import { lazy, Suspense, forwardRef } from 'react';

const LazyChat = lazy(
  () =>
    import(
      /* webpackChunkName: "saas-ui-chat" */
      /* webpackPrefetch: true */
      './Chat'
    ),
);

export default forwardRef(function Chat(props, ref) {
  return (
    <Suspense fallback={null}>
      <LazyChat {...props} ref={ref} />
    </Suspense>
  );
});
